import React, { memo, useEffect, useState, useContext } from 'react'
import Link from 'next/link'
import cn from 'classnames'
// Utils
import styles from './BreedList.module.scss'
import { useMediaQuery } from '@utils'
import cities from '@/utils/us-cities.json'
import { DogsLandingsContext } from '@context/dogsLandingsContext'

type CityLinkProps = {
  name: string
  state: string
  link: string
}

const CityLink = memo(({ name, state, link }: CityLinkProps) => {
  const isMobile = useMediaQuery('(max-width:600px)')
  const shortName = name?.length > 20 ? name?.slice(0, 20) + '...' : name
  return (
    <div
      className={cn(styles.listItem, styles.link)}
      style={{ cursor: 'pointer' }}
    >
      <Link href={link}>
        <p>
          <span style={{ textTransform: 'capitalize' }}>
            {isMobile ? shortName : name},
          </span>{' '}
          {state}
        </p>
      </Link>
    </div>
  )
})

type CitiesListProps = {
  title: string
  less: string
  more: string
  breedName?: string
  type: string
}

const CitiesList = memo(
  ({ title, less, more, breedName, type }: CitiesListProps) => {
    const { variables } = useContext(DogsLandingsContext)

    const [showAll, setShowAll] = useState(false)
    const [hasLoaded, setHasLoaded] = useState(false)

    const { stateSlug = '', state = '', slug = '', citySlug = '' } = variables

    const allCitiesOfState = cities
      .filter(
        (elem) =>
          elem.state === state &&
          elem.slug.toLowerCase() !== citySlug.toLowerCase()
      )
      .sort((a, b) => (a.city > b.city ? 1 : -1))
    const mainCities = allCitiesOfState.slice(0, 10)

    // Check if Javascript is fully loaded
    useEffect(() => {
      setHasLoaded(true)
    })

    const linkResolver = (firstRoute, secondRoute) =>
      type === 'breed-state'
        ? `/puppies-for-sale/${breedName}/${firstRoute}/${secondRoute}`
        : `/puppies-for-sale/${firstRoute}/${secondRoute}`

    if (allCitiesOfState.length === 0) {
      return null
    }

    return (
      <div className={styles.breedListWrapper}>
        <div className={styles.article}>
          <div className={styles.articleContent}>
            <h2 className={styles.title}> {title} </h2>

            <div className={styles.data}>
              {mainCities?.length > 0 &&
                mainCities.map((c) => (
                  <CityLink
                    key={c.id}
                    name={c.city}
                    state={c.state}
                    link={linkResolver(stateSlug || slug, c.slug)}
                  />
                ))}

              {!hasLoaded &&
                mainCities?.length > 0 &&
                mainCities.map((c) => (
                  <CityLink
                    key={c.id}
                    name={c.city}
                    state={c.state}
                    link={linkResolver(stateSlug || slug, c.slug)}
                  />
                ))}

              {showAll &&
                allCitiesOfState.length > 10 &&
                allCitiesOfState.map((c) => (
                  <CityLink
                    key={c.id}
                    name={c.city}
                    state={c.state}
                    link={linkResolver(stateSlug || slug, c.slug)}
                  />
                ))}
            </div>
          </div>

          {hasLoaded && allCitiesOfState.length > 10 && (
            <div
              onClick={() => setShowAll((curr) => !curr)}
              className={styles.view}
            >
              <p>
                {showAll ? less : more}{' '}
                <span>
                  <img
                    width="11px"
                    height="6px"
                    alt={showAll ? 'Black up arrow' : 'Black down arrow'}
                    src={
                      showAll
                        ? '/search/arrow-top-black.svg'
                        : '/search/arrow-down-black.svg'
                    }
                  />
                </span>
              </p>
            </div>
          )}
        </div>
      </div>
    )
  }
)

export default CitiesList
